import { render, staticRenderFns } from "./StockAddDialog.vue?vue&type=template&id=3caa6c0c&scoped=true"
import script from "./StockAddDialog.vue?vue&type=script&lang=js"
export * from "./StockAddDialog.vue?vue&type=script&lang=js"
import style0 from "./StockAddDialog.vue?vue&type=style&index=0&id=3caa6c0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3caa6c0c",
  null
  
)

export default component.exports